const redirectsMixin = {
  methods: {
    /**
     * Navigate to sign in page
     */
    navigateToSignIn() {
      this.$router.push("/sign-in");
    },

    /**
     * Navigate to signup page
     */
    navigateToSignUp() {
      this.$router.push("/sign-up");
    },

    /**
     * Navigate to forgot password page
     */
    navigateToForgotPassword() {
      this.$router.push("/forgot-password");
    },

    /**
     * Navigate to give path
     * @param {String} path path
     */
    navigateToPath(path) {
      this.$router.push(`/${path}`);
    },
  },
};

export default redirectsMixin;
